<template lang="pug">
ImageSvg(
    :src="logoUrl"
    :height="28"
    :alt="`${state.merchant.name} логотип`"
    width="auto"
)
</template>

<script lang="ts">
import Vue from 'vue'

import { useAppStore } from '@/shared/model'
import { ImageSvg } from '@/shared/ui/ImageSvg'

export default Vue.extend({
    name: 'MerchantLogo',
    setup() {
        const { state, logoUrl } = useAppStore()
        return {
            state,
            logoUrl,
        }
    },
    components: {
        ImageSvg,
    },
})
</script>
